import { jsx } from 'react/jsx-runtime';
import Toolbar from '../ui/Toolbar/Toolbar.js';
import { basicGroup, structuralFormattingGroup, textFormattingGroup, positioningGroup, mediaGroup } from '../ui/Toolbar/toolbarConfig.js';
import { ToolbarItemType } from '../ui/Toolbar/types.js';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';

const desktopFixedToolbarGroups = [
  structuralFormattingGroup,
  mediaGroup,
  basicGroup
];
const mobileFixedToolbarGroups = [
  basicGroup,
  structuralFormattingGroup,
  textFormattingGroup,
  positioningGroup,
  mediaGroup,
  {
    name: "done",
    label: "Done",
    items: [
      {
        label: "Done",
        type: ToolbarItemType.Button,
        key: "done",
        onClick: (editor) => {
          setTimeout(() => {
            editor.chain().focus().blur().run();
          }, 10);
        }
      }
    ]
  }
];
const FixedToolbar = ({ editor, onToolbarHeightChange }) => {
  const { isMobile } = useResponsive();
  return /* @__PURE__ */ jsx(Toolbar, {
    editor,
    onToolbarHeightChange,
    groups: isMobile() ? mobileFixedToolbarGroups : desktopFixedToolbarGroups
  });
};

export { FixedToolbar as default };
//# sourceMappingURL=FixedToolbar.js.map
